import LoadingDots from "@components/LoadingDots";
import { images } from "@img/imagesMap";
import * as excel from "@script/excel";
import { useState } from "react";
import ExcelUploadTemplate from "./ExcelUploadTemplate";

export default function MgmtMworksTab_division() {
  const [excelFileName, setExcelFileName] = useState<string>();
  const [excelDataMworks, setExcelDataMworks] = useState<any | null>(null);

  const [isUpload, setIsUpload] = useState(false);

  async function handleFileUpload(file: File) {
    setExcelDataMworks(null);

    setIsUpload(true);

    // ===== 파일 용량 체크 =====
    if (file.size > 10 * 1024 * 1024) {
      alert("❌ 파일 크기는 10MB를 초과할 수 없습니다.");
      setIsUpload(false);
      return;
    }

    // ===== 확장자 체크 =====
    const lower = file.name.toLowerCase();
    if (!lower.endsWith(".xlsx") && !lower.endsWith(".xls")) {
      alert("❌ 지원되지 않는 파일 형식입니다. (.xlsx, .xls만 지원)");
      setIsUpload(false);
      return;
    }

    setExcelFileName(file.name);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const uploadResult = await excel.upload_mworks_division(formData);

      /**
       * 백엔드가 리턴하는 구조
       * 1) 성공 → { result: "succeed" }
       * 2) 오류 → array of rows
       */
      if (uploadResult?.result === "succeed") {
        setExcelDataMworks({ result: "succeed" });
      } else if (Array.isArray(uploadResult)) {
        setExcelDataMworks(uploadResult); // 오류 테이블 표시
      } else {
        setExcelDataMworks({ result: "fail" });
      }
    } catch (error) {
      console.error(error);
      setExcelDataMworks({ result: "serverError" });
    } finally {
      setIsUpload(false);
    }
  }

  return (
    <ExcelUploadTemplate
      title="부서 등록"
      templateUrl="/template/easysetting_division.xlsx"
      templateFileName="부서등록_템플릿.xlsx"
      onFileUpload={handleFileUpload}
      isUpload={isUpload}
      excelFileName={excelFileName}
    >
      {/* ===== 업로드 결과 영역 ===== */}
      {excelDataMworks && (
        <div className="mgmtMworks_uploadResult">
          {/* 성공 */}
          {excelDataMworks.result === "succeed" ? (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--ok">
              업로드가 완료되었습니다
            </div>
          ) : Array.isArray(excelDataMworks) ? (
            <>
              {/* 오류 테이블 */}
              <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
                업로드 오류가 있습니다.
              </div>

              <table className="mgmtMworks_uploadError_table">
                <thead>
                  <tr>
                    <th>행번호</th>
                    <th>1Depth</th>
                    <th>2Depth</th>
                    <th>3Depth</th>
                    <th>오류 유형</th>
                  </tr>
                </thead>
                <tbody>
                  {excelDataMworks.map((item: any, idx: number) => (
                    <tr key={idx}>
                      <td className="mgmtMworks_uploadError_td">{item.num}</td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth1}</td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth2}</td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth3}</td>
                      <td className="mgmtMworks_uploadError_td mgmtMworks_uploadError_td--label">
                        {item.errorType}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
              업로드에 실패하였습니다.
            </div>
          )}
        </div>
      )}
    </ExcelUploadTemplate>
  );
}